module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content-wrapper dashboard-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "box palette-Pink-300 bg",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'devices'
        })
      }
    }
  }, [_c('div', {
    staticClass: "box-header   palette-Pink-300 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium ti-car"
  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Devices")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#ffffff', '#ffffff']
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-white"
  }, [_c('strong', [(!_vm.loading) ? _c('animate-number', {
    attrs: {
      "from": 0,
      "to": _vm.pagination.totalCount,
      "duration": "1000",
      "easing": "easeOutQuad"
    }
  }) : _vm._e()], 1)])], 1)])])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-093b0f3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Index.vue
// module id = 1140
// module chunks = 2